import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const DatePickerBaseFieldStyles = {
  buttonStyle: css`
    outline: none;
    &:focus {
      color: ${theme.colors.primary50};
    }
  `,
};
